export default __webpack_public_path__ + "static/media/space45.af7e89bc.jpg";